import React, { useRef, useEffect, useState } from "react";
import YouTube from "react-youtube";

const VideoComponent = () => {
  // const videoRef = useRef(null);
  // const [isVisible, setIsVisible] = useState(false);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setIsVisible(entry.isIntersecting);
  //     },
  //     { threshold: 0.5 }
  //   );

  //   if (videoRef.current) {
  //     observer.observe(videoRef.current);
  //   }

  //   return () => {
  //     if (videoRef.current) {
  //       observer.unobserve(videoRef.current);
  //     }
  //   };
  // }, [videoRef]);

  // useEffect(() => {
  //   if (isVisible) {
  //     videoRef.current.play();
  //   } else {
  //     videoRef.current.pause();
  //   }
  // }, [isVisible]);

  const onPlayerReady = (event) => {
    event.target.mute(); // Mute the video
  };

  const opts = {
    height: "1000",
    width: "100%",
    playerVars: {
      autoplay: 1,
      controls: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
    },
  };

  return (
    <>
      {/* <video
        ref={videoRef}
        poster="/pdf/dc-fallback-video.png"
        autoPlay
        loop
        muted
        style={{ width: "100%", height: 600, objectFit: "cover" }}
      >
        <source src={`/pdf/dc-video-11.mp4`} type="video/mp4" />
      </video> */}
      <YouTube videoId="KhFpoByAw3w" opts={opts} onReady={onPlayerReady} />;
      {/* <iframe width="100%" height="600" src="https://www.youtube.com/embed/KhFpoByAw3w?si=BFAfmesokahXEEd2&amp;controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowFullscreen></iframe> */}
    </>
  );
};

export default VideoComponent;
